import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LocalizedText, ReleaseNote } from 'src/app/core/models/release-note';
import { ReleaseNotesService } from 'src/app/core/services/release-notes.service';

/** Presentational list of curated releases. Reused by the login dialog and the home page. */
@Component({
  selector: 'app-release-notes-list',
  templateUrl: './release-notes-list.component.html',
  styleUrls: ['./release-notes-list.component.scss'],
})
export class ReleaseNotesListComponent {
  releases$: Observable<ReleaseNote[]> = this.releaseNotes.getReleases();

  constructor(private releaseNotes: ReleaseNotesService, private translate: TranslateService) {}

  /** Pick the active-language string; fall back to Italian (the default locale). */
  localized(text: LocalizedText): string {
    return this.translate.currentLang === 'en' ? text.en : text.it;
  }
}
